import { render, staticRenderFns } from "./MarkExamPage.vue?vue&type=template&id=fa1c04b4&scoped=true"
import script from "./MarkExamPage.vue?vue&type=script&lang=js"
export * from "./MarkExamPage.vue?vue&type=script&lang=js"
import style0 from "./MarkExamPage.vue?vue&type=style&index=0&id=fa1c04b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1c04b4",
  null
  
)

export default component.exports